import { downloadFile } from "../../../shared/utils/converter";

export const printUsersTable = () => {
  const tableArea = document.querySelector(".logs-table-area");
  if (!tableArea) return;

  const table = tableArea.querySelector("table");
  if (!table) return;

  const tableClone = table.cloneNode(true);
  const ths = tableClone.querySelectorAll("th");
  ths.forEach((th) => {
    th
      .querySelectorAll("svg, i, span[class*=icon], .fa, .svg-inline--fa")
      .forEach((el) => el.remove());
  });

  const printWindow = window.open("", "", "width=900,height=700");
  if (!printWindow) return;

  printWindow.document.write("<html><head><title>Print Table</title>");
  printWindow.document.write(
    "<style>body{font-family:sans-serif;padding:16px;}table{width:100%;border-collapse:collapse;}th,td{border:1px solid #ccc;padding:8px;text-align:left;}th input,td input,button{display:none!important;}</style>",
  );
  printWindow.document.write("</head><body>");
  printWindow.document.write(
    "<table>" +
      (tableClone.tHead ? tableClone.tHead.outerHTML : "") +
      (tableClone.tBodies[0] ? tableClone.tBodies[0].outerHTML : "") +
      "</table>",
  );
  printWindow.document.write("</body></html>");
  printWindow.document.close();
  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
};

export const exportUsersToCsv = (users) => {
  if (!Array.isArray(users) || users.length === 0) return;

  const headers = [
    "First Name", "Last Name", "To Address (PBX Email)",
    "Delivery Address (Email)", "Email Mode", "SMS Mode",
    "Mobile Number", "Voicemail Number", "Time Zone",
  ];
  const rows = users.map((u) => [
    u.firstName, u.lastName, u.toAddress, u.deliveryAddress,
    u.emailMode, u.smsMode, u.mobileNumber, u.voicemailNumber, u.timeZone,
  ]);
  const csvContent = [headers, ...rows]
    .map((row) => row.map((cell) => `"${(cell ?? "").toString().replace(/"/g, '""')}"`).join(","))
    .join("\n");

  downloadFile("users.csv", csvContent, "text/csv;charset=utf-8;");
};
